import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { UserState } from "../store/constants";

export const selectUserSlice = (state: RootState): UserState => state.user;

export const selectUserValue = createSelector(selectUserSlice, (u) => u.value);

export const selectUserStatus = createSelector(selectUserSlice, (u) => u.status);

export const selectSportsType = createSelector(selectUserSlice, (u) => u.sportsType);

export const selectAreaOfInterest = createSelector(selectUserSlice, (u) => u.areaOfInterest);

export const selectFavorites = createSelector(selectUserSlice, (u) => u.favorites);

export const selectLanguage = createSelector(selectUserSlice, (u) => u.language);


export const selectIsLoggedIn = createSelector(selectUserSlice, (u) => Boolean(u.value));


